var PDMLightbox = (function () {
  // Lightbox reset - present on all pages
  var lightbox = document.querySelector(".pdm-lightbox");
  var lightboxContent = document.querySelector(
    ".pdm-lightbox .pdm-lightbox__content"
  );

  // Delegated click handler (replaces $("body").on(...))
  document.body.addEventListener("click", function (e) {
    var trigger = e.target.closest(
      "[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger"
    );

    if (!trigger) return;

    e.preventDefault();

    var content = "";

    if (trigger.dataset.lightboxContent) {
      content = trigger.dataset.lightboxContent;
    } else if (trigger.dataset.lightboxTarget) {
      var target = document.getElementById(
        trigger.dataset.lightboxTarget
      );
      content = target ? target.innerHTML : "";
    } else {
      var next = trigger.nextElementSibling;
      if (next && next.classList.contains("lightbox-content")) {
        content = next.innerHTML;
      }
    }

    if (lightboxContent) {
      // lightboxContent.innerHTML = content;
    }

    var classes = trigger.dataset.lightboxClasses;
    if (lightbox) {
      lightbox.classList.add("active");
      if (classes) {
        classes.split(" ").forEach(function (cls) {
          if (cls) lightbox.classList.add(cls);
        });
      }
    }
  });

  function closeModal(lightboxEl) {
    if (!lightboxEl) return;

    lightboxEl.classList.remove("active");
    document.body.classList.remove("noScroll");

    if (lightboxEl.classList.contains("pdm-lightbox--reset")) {
      setTimeout(function () {
        var contentEl = lightboxEl.querySelector(
          ".pdm-lightbox__content"
        );
        if (contentEl) contentEl.innerHTML = "";

        lightboxEl.className = "pdm-lightbox pdm-lightbox--reset";
      }, 750);
    }
  }

  function openModal(lightboxEl) {
    if (!lightboxEl) return;

    lightboxEl.classList.add("active");
    document.body.classList.add("noScroll");
  }

  function updateModal(lightboxEl, content) {
    if (!lightboxEl) return;

    var contentEl = lightboxEl.querySelector(
      ".pdm-lightbox__content"
    );
    if (contentEl) {
      contentEl.innerHTML = content;
    }
  }

  // Close when clicking backdrop
  document.querySelectorAll(".pdm-lightbox").forEach(function (lb) {
    lb.addEventListener("click", function (e) {
      if (e.target === lb) {
        closeModal(lb);
      }
    });
  });

  // Close button
  document
    .querySelectorAll(".pdm-lightbox__close")
    .forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var lb = btn.closest(".pdm-lightbox");
        closeModal(lb);
      });
    });

  return {
    close: closeModal,
    open: openModal,
    update: updateModal,
  };
})();